import { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

export type ContactPageFaqCard = {
  description: ReactNode | ReactNode[]
  href: string
  title: string
}

export const ContactPageFaqCardsSectionCard: FC<ContactPageFaqCard> = ({
  description,
  href,
  title,
}) => {
  return (
    <div className="relative flex w-full flex-col justify-between rounded-xl bg-light-brand-medium p-4 hover:bg-light-brand-high hover:shadow-m">
      <div className="text-left">
        <p className="mb-2 text-l font-medium">{title}</p>
        <p className="line-clamp-4 text-m text-dark-primary-strong">
          {description}
        </p>
      </div>
      <Button<'a'>
        className="mt-2 w-full items-end justify-between after:absolute after:inset-0"
        endIcon={<IconArrowRight className="text-dark-hover-brand" />}
        href={href}
        size="large"
        slots={{ root: 'a' }}
        variant="text"
      >
        <FormattedMessage id="contact.faqCardsSection.card.cta.label" />
      </Button>
    </div>
  )
}
